import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import './../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './assets/css/feather.css'
import './assets/css/materialdesignicons.min.css'
import './assets/css/vendor.bundle.base.css'
import './assets/css/font-awesome.min.css'
import './assets/css/font.css'
import './assets/css/style.css'
import '../node_modules/react-toastify/dist/ReactToastify.css'

import ProviderContext from './Context/ProviderContext'

import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <ProviderContext>
  <App />
</ProviderContext>
,
  document.getElementById('root')
);

reportWebVitals();